<template>
  <div>
    <div class="fixedNavbar">
      <div class="top">
        <img src="../../assets/img/advertisement.png" alt="" />
      </div>
      <div class="bottom">
        <div class="box">
          <img :src="'https://api.qrserver.com/v1/create-qr-code?data=' + obj.uploadAddress" alt="" />
          <!-- <img :src="obj.uploadAddress" alt="" /> -->
          <span>安卓下载</span>
        </div>
            <div class="box">
              <img src="../../assets/img/ios_download.png" alt="" />
              <span>ios下载</span>
            </div>
        <!-- <div class="box">
          <img :src="'data:image/jpg;base64,' + img" alt="" />
          <span>ios下载</span>
        </div> -->
        <div class="box">
          <img src="../../assets/img/wxxcx.jpg" alt="" />
          <span>微信小程序</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "freeHealthTest",
  components: {},
  data () {
    return {
      token: undefined,
      obj: {}
    };
  },
  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff;");
  },
  created () {
    this.token = this.$route.query.appToken;
    this.getCheckVersionInfo();
  },
  mounted () {},
  methods: {
    // 201安卓202ios
    getCheckVersionInfo () {
      var param = {
        service: "openapi",
        query: {
          versionNo: "v1.0.0",
          versionType: 201,
          agencyId: 0,
          isMatches: 2
        }
      };
      this.$api
        .getCheckVersionInfo(param)
        .then((res) => {
          if (res) {
            this.obj = res.data.result;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          console.log("finally");
        });
    }
  }
};
</script>

<style scoped lang="less">
.fixedNavbar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2032;
}
.top {
  width: 100%;
  height: 883px;
  padding-top: 16px;
  img {
    width: 100%;
    height: 100%;
  }
}
.bottom {
  // width: 100%;
  flex: 1;
  padding: 0 120px;
  padding-top: 100px;
  display: flex;
  justify-content: space-between;
  .box {
    width: 111px;
    text-align: center;
    display: flex;
    flex-direction: column;
    img {
      width: 111px;
      height: 111px;
    }
    span {
      font-size: 9px !important;
      font-weight: 400;
      color: #0d2041;
      line-height: 19px;
      padding-top: 20px;
      white-space: nowrap;
    }
  }
}
</style>
